import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React from 'react';
import { format } from 'date-fns';
import './CopyrightLabel.css';

var CopyrightLabel = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CopyrightLabel, _React$PureComponent);

  var _super = _createSuper(CopyrightLabel);

  function CopyrightLabel() {
    _classCallCheck(this, CopyrightLabel);

    return _super.apply(this, arguments);
  }

  _createClass(CopyrightLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          year = _this$props.year,
          company = _this$props.company,
          phrase = _this$props.phrase,
          privacyPolicyLink = _this$props.privacyPolicyLink;
      return /*#__PURE__*/React.createElement("div", {
        className: "fc-copyright-label"
      }, /*#__PURE__*/React.createElement("span", {
        role: "img",
        "aria-label": "Copyright"
      }, "\xA9"), /*#__PURE__*/React.createElement("span", null, year || format(new Date(), 'yyyy'), " ", company, " ", phrase), privacyPolicyLink && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
        className: "privacy-policy-link"
      }, privacyPolicyLink)));
    }
  }]);

  return CopyrightLabel;
}(React.PureComponent);

export { CopyrightLabel as default };
CopyrightLabel.defaultProps = {
  company: '',
  phrase: '',
  year: null,
  privacyPolicyLink: null
};
CopyrightLabel.propOptions = {};
CopyrightLabel.dataPropsMap = {
  company: ['business', 'name']
};